<template>
  <div class="chart">
    <h4 class="title">{{ title }}</h4>
    <vue-apex-chart type="pie" :options="options" :series="series"/>
  </div>
</template>
<script>
  import keys from 'lodash/keys'
  import map from 'lodash/map'
  import sum from 'lodash/sum'
  import VueApexChart from 'vue-apexcharts'
  import Ncs from 'ncs'
  import {locales} from '../apexcharts_locales'

  export default {
    extends: Ncs.defaultComponents.NcsFullFrequencyResultTable,
    components: {VueApexChart},
    computed: {
      title() {
        return this.$t(`result.full_frequency.${this.group}.header`)
      },
      series() {
        return map(this.frequencyPerValue, 'elements')
      },
      total() {
        return sum(this.series)
      },
      categories() {
        return keys(this.frequencyPerValue)
      },
      translatedCategories() {
        return this.categories.map(c => this.$t(`result.full_frequency.${this.group}.values.${c}`))
      },
      options() {
        return {
          labels: this.translatedCategories,
          tooltip: {
            y: {formatter: v => `${v} (${this.formatNumber(v / this.total * 100, 2)}%)`}
          },
          chart: {
            locales,
            defaultLocale: this.$i18n.locale,
            toolbar: {show: true},
            events: {
              dataPointSelection: (event, chartContext, {dataPointIndex}) => this.showKwic(this.categories[dataPointIndex])
            }
          },
          theme: {
            monochrome: {
              enabled: true,
              color: '#008751',
              shadeIntensity: 0.9
            }
          }
        }
      }
    },
    methods: {
      formatNumber(number) {
        const delimiter = this.$t('number.format.delimiter') === '&nbsp;' ? ' ' : this.$t('number.format.delimiter')
        return this.$fn(number, {delimiter})
      }
    }
  }
</script>
<style lang="scss">
  // See: https://github.com/apexcharts/apexcharts.js/issues/2313
  .apexcharts-menu-item.exportCSV { display: none; }
</style>
